"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitKarjala = void 0;
function InitKarjala() {
    const isIOS = () => {
        if (/iPad|iPhone|iPod/.test(navigator.platform)) {
            return true;
        }
        else {
            return navigator.maxTouchPoints &&
                navigator.maxTouchPoints > 2 &&
                /MacIntel/.test(navigator.platform);
        }
    };
    const showHiddenElementsOnLoad = () => {
        jQuery('.o-history-events').addClass('ready');
    };
    const showHiddenElementsOnReady = () => {
        jQuery('body.karjala.HistoryPage .hero-image~section .u-mb-0').addClass('ready');
    };
    $(window).on('load', function () {
        showHiddenElementsOnLoad();
    });
    jQuery(document).ready(function () {
        setTimeout(() => {
            showHiddenElementsOnReady();
        }, 200);
        if (jQuery('.o-history-events').length) {
            jQuery('.o-history-events').addClass('show-loader');
            if (jQuery(window).scrollTop() > jQuery(window).innerHeight()) {
                jQuery('.o-history-events').addClass('fixed');
            }
        }
        // YouTube video autoplay after preview play button click
        jQuery('.youtube .play-video').click(function () {
            const iFrm = jQuery(this).parents('.o-video-container').children('iframe');
            console.log('iFrm', iFrm);
            if (iFrm.length) {
                const win = window.$(iFrm)[0];
                win.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            }
        });
        jQuery("#content-link").click(function () {
            let linkTargetPos = jQuery('.hero-image').position().top + jQuery('.hero-image').height();
            linkTargetPos = (jQuery(window).innerWidth() > 1200) ? linkTargetPos + 100 : linkTargetPos + 50;
            if (isIOS()) {
                jQuery(window).scrollTop(linkTargetPos);
            }
            else {
                $("html, body").animate({ scrollTop: linkTargetPos });
            }
        });
        // UnBind default click event to redefine it
        $(".o-back-to-top").unbind("click");
        jQuery(".o-back-to-top").click(function (e) {
            e.preventDefault();
            // Add iOS check
            if (isIOS()) {
                jQuery(window).scrollTop(0);
            }
            else {
                $("html, body").animate({ scrollTop: 0 }, "slow");
            }
        });
    });
}
exports.InitKarjala = InitKarjala;
